import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { buttonVariants } from '../components/ui/button.tsx';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-[60dvh] place-items-center text-center">
      <div>
        <p className="font-mono font-semibold text-primary text-sm">404</p>
        <h1 className="mt-2 font-semibold text-2xl text-ink">{t('notFound.title')}</h1>
        <p className="mt-2 text-ink-muted">{t('notFound.body')}</p>
        <Link to="/" className={buttonVariants({ className: 'mt-6' })}>
          {t('notFound.home')}
        </Link>
      </div>
    </div>
  );
}
